import Pivot from './components/Pivot.vue'
import PivotTable from './components/PivotTable.vue'

export {
  Pivot,
  PivotTable
}

export default {
  Pivot,
  PivotTable
}
